module.exports = __webpack_public_path__ + "mainassets/img/meshlin_main-vector-gallery.f33f754e.svg";